import { useMemo } from 'react'
import { queryKeyCurrency, queryKeyPriceTotal } from 'constants/url'
import {
  type MetasearchAdvertisedPrice,
  parseMetasearchAdvertisedPrice,
} from 'lib/metasearch/metasearchAdvertisedPrice'
import useQueryParams from './useQueryParams'

/**
 * Google's displayed total for the current metasearch landing, read from the URL alongside
 * {@link useMetasearchPriceId} (`gpid`) and {@link useMetasearchRuleId} (`ruleId`). The pair
 * rule lives in {@link parseMetasearchAdvertisedPrice}.
 *
 * Memoised on the raw params: callers spread this into the discount request and list it in
 * effect dependencies, so a fresh object each render would re-run those effects on every render.
 */
export default function useMetasearchAdvertisedPrice(): MetasearchAdvertisedPrice | undefined {
  const query = useQueryParams()
  const total = query.get(queryKeyPriceTotal)
  const currency = query.get(queryKeyCurrency)

  return useMemo(() => parseMetasearchAdvertisedPrice(total, currency), [total, currency])
}
